<template>
    <div class="navigation">
        <div v-if="showPopup" class="nav-overlay" @click="toggleOpen"></div>
        <button class="open-menu" :class="{ open: showPopup }" @click="showNav">
            <span></span>
            <span></span>
            <span></span>
        </button>

        <div class="toggle-popup" :class="{ open: showPopup }"  >
            <ul>
                <li class="d-flex d-lg-none"><account-info></account-info></li>
                <li v-for="(item, i) in $store.state.apiData.menu_items" :key="i"><a :target="item.self ? '_self' : '_blank'" :href="item.url">{{ item.name }}</a></li>
                <li v-if="!$loggedIn"><a @click.prevent="$login" href="#">Login iDD Klantdossier</a></li>
                <li v-else><a @click.prevent="$logout" href="#">Uitloggen</a></li>
            </ul>
        </div>
    </div>
</template>

<script>
    import AccountInfo from '../components/AccountInfo.vue'

    export default {
        components: {
            AccountInfo
        },
        data() {
            return {
                showPopup: false,
                parent:  this.$parent,
            }
        },
        methods: {
            showNav: function () {
                this.showPopup = !this.showPopup
                document.body.classList.toggle('drop-down-open-nav')
                this.parent.checkOpenPref()
            },
            toggleOpen: function () {
                this.showPopup = false
                document.body.classList.remove('drop-down-open-nav')
            }
        }
    }
</script>

<style>
    .nav-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
</style>
